// src/icons/RightArrowIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function RightArrowIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 12,
    viewBox: "0 0 21 12",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M20.5303 6.53033C20.8232 6.23744 20.8232 5.76256 20.5303 5.46967L15.7574 0.696699C15.4645 0.403806 14.9896 0.403806 14.6967 0.696699C14.4038 0.989593 14.4038 1.46447 14.6967 1.75736L18.9393 6L14.6967 10.2426C14.4038 10.5355 14.4038 11.0104 14.6967 11.3033C14.9896 11.5962 15.4645 11.5962 15.7574 11.3033L20.5303 6.53033ZM0 6.75H20V5.25H0V6.75Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  RightArrowIcon
};
//# sourceMappingURL=RightArrowIcon.mjs.map